module.exports = __webpack_public_path__ + "img/sub_page_communication22.dc5b86b2.png";